<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary" style="margin-bottom:30px;">
                    <v-toolbar-title>Conversa com {{nomeChat}}</v-toolbar-title>
                    <!-- <v-btn flat @click="dialogNewUsers = true" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn> -->
                </v-toolbar>

                

                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                
                <v-flex v-for="(item, index) in itemsMensagens" xs12 sm6 md4 row class="boxMensagem" style="margin-bottom:5px; padding:1px">
                    
                    <div class="imagem miniatura-perfil outraImagem" v-bind:style="{ 'background-image': 'url(' + imgOutraPessoa + ')' }" v-if="slugUsuarioLogado!=item.slugAutor"></div>
                    <div class="imagem miniatura-perfil minhaImagem" v-bind:style="{ 'background-image': 'url(' + minhaImg + ')' }" v-if="slugUsuarioLogado==item.slugAutor"></div>
                    
                    <v-card :class="{'eu' : (slugUsuarioLogado==item.slugAutor) }">
                    
                        <v-card-text>
                            <v-btn class="deletar" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn>
                            <v-card-title primary-title>
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div style="width:100%" class="body-content">
                                    <h3 class="headline mb-0" :title="item.mensagem">{{item.mensagem}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                </div>
                            </v-card-title>  

                            <!--v-card-actions>
                                <div class="instagram" style="height:20px;"><a :href="item.instagram" target="_blank" v-if="item.instagram != ''"><img width="20px" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/599px-Instagram_icon.png"></a></div>
                                <v-btn class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <v-btn class="release" flat color="orange" flat="flat" @click="displayItem(item.slug)">Perfil</v-btn>
                            </v-card-actions-->
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
                    <v-text-field style="margin-left:20px; width:50%" browser-autocomplete="new-texto" name="texto" label="Digite o texto" type="text"
                                    v-model="texto" data-cy="joinEmailField" required>
                    </v-text-field>
                    <v-btn color="green darken-1" style="border: solid 1px #43a047; position:relative; top: 8px" flat @click="enviarMensagem">Enviar</v-btn>
                
                
            
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Mensagem deletada com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="carregaDados">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar mensagem?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js';

import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
    name: 'Chat',
    data () {
        return {
            minhaImg: null,
            imgOutraPessoa: null,
            slug : '',
            perfil: userProperties.perfil,
            slugUsuarioLogado: userProperties.slug,
            dialogDeleteConfirm: false,
            dialogNewUsers: false,
            dialog: false,
            loading: false,
            modalMessage: 'Mensagem excluída com sucesso!',
            items: [],
            texto: '',
            ordemSlug: null,
            nomeChat: null,
            usuario: {
                // alunoSlug: 1,
                // alunoName: 'Alice'
            },
            itemsMensagens: [
                // {
                //         alunoSlug: 0,
                //         alunoName: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ],
            ordem: null // ordena a exibição das mensagens
        }
        
    },
    methods: {
        carregaDados() {


            

            this.dialog = false
            this.items = []
            this.itemsMensagens = []
            //this.loading = true
            let obj = []

            // Ordenar exibicao -0 numerica
            function ordenarPorTimestamp(a, b){
                return a.ordem - b.ordem; // crescente
                //return b.timestamp - a.timestamp; // decrescente
            }

            var ordemSlug = null;
            //.replace(/\D/g,'') para remover todas as letras da string - deixar somente numeros
            if(Number(userProperties.slug.replace(/-/g, '').replace(/\D/g,'')) < Number(this.$route.query.slug.replace(/-/g, '').replace(/\D/g,''))){
                ordemSlug = userProperties.slug + this.$route.query.slug;
            }
            else{
                ordemSlug = this.$route.query.slug + userProperties.slug;
            }
        
            this.ordemSlug = ordemSlug;

            let ref = db.collection('mensagens_'+userProperties.escolaID).where("AB", "==", ordemSlug);
            ref.onSnapshot(snapshot => {
                snapshot.docChanges().forEach(change => {
                    //if (change.type = 'added') {
                        this.ordem = snapshot.size; // ordena a exibição das mensagens
                        let doc = change.doc;
                        this.itemsMensagens.push({
                            //id: doc.id,
                            //name: doc.data().name,
                            slug: doc.data().slug,
                            mensagem: doc.data().mensagem,
                            customtimestamp: doc.data().customtimestamp,
                            customtimestampServer: doc.data().customtimestampServer,
                            slugAutor: doc.data().slugAutor,
                            ordem: doc.data().ordem // ordena a exibição das mensagens
                        });
                    //}
                    // ordenar exibicao - numerica
                    document.body.scrollTop = document.body.scrollHeight;
                    // this.itemsMensagens.sort(ordenarPorTimestamp);
                });
                // ordenar exibicao - numerica
                this.itemsMensagens.sort(ordenarPorTimestamp);
                
            });
            
            // Busca nome pelo Slug
            //var responsaveisDoAlunoSlug = [];
            usersData.usuarios.forEach((item, index) => {
                if(item.slug == this.$route.query.slug){
                    this.nomeChat = item.nome;
                    this.imgOutraPessoa = this.$route.query.slug + "." + item.extensao;
                }
            });

            usersData.usuarios.forEach((item, index) => {
                if(item.slug == userProperties.slug){
                    this.minhaImg = userProperties.slug + "." + item.extensao;
                }
            });

            // recupera imagem do firebase storage
            var storageRef = firebase.storage().ref();
            var tangRef = storageRef.child('profile/'+this.imgOutraPessoa);
            tangRef.getDownloadURL().then(urlImgFB =>                             {
                // Once we have the download URL, we set it to our img element
                this.imgOutraPessoa = urlImgFB;
            }).catch(function(error) {
                console.error(error);
            });

            var tangRef = storageRef.child('profile/'+this.minhaImg);
            tangRef.getDownloadURL().then(urlImgFB =>                             {
                // Once we have the download URL, we set it to our img element
                this.minhaImg = urlImgFB;
            }).catch(function(error) {
                console.error(error);
            });

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "acessar",
                        categoria: "chat",
                        pontos: 1
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);
                        // rolagem para o final da pagina
                        document.body.scrollTop = document.body.scrollHeight;

                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }



            // Excluir item da notificacao
            this.loading = true
            db.collection("notificacoes").where("escolaID", "==", userProperties.escolaID).where("destinatario", "==", userProperties.slug).where("enviadoPor", "==", this.$route.query.slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                        console.log("Document successfully deleted!");
                        //chama a funcao que verifica a quantidade de notificacoes e atualiza o cookie
                        this.verificaNotificacoes();
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
                this.loading = false;
            });

        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        verificaNotificacoes(){
            // Popula o numero de quantidade de notificações
            db.collection('notificacoes').where("destinatario", "==", userProperties.slug)
            .get()
            .then((querySnapshot) => {
                // set cookie
                $.cookie("qtdNotificacoes", querySnapshot.size, { expires: 1 });
                
                
            });
        },
        notificacaoAdd(AB, destinatario, enviadoPor){
            const slug = this.generateUUID();
            var tokenFCM = null;
                
            db.collection('notificacoes').add({
                escolaID: userProperties.escolaID,
                //slugAutor: userProperties.slug,
                slug: slug,
                AB: AB,
                destinatario: destinatario,
                enviadoPor: enviadoPor
            })
            .then(docRef => {
                console.log('Document written with ID: ', docRef.id);
                usersData.usuarios.forEach((item, index) => {

                    if(item.slug == destinatario){
                        tokenFCM = item.tokenFMC;
                    }
                });
                var postData = {
                    "notification": {        
                        "title": "Nova mensagem!",
                        "body": "Você recebeu uma nova mensagem no chat.",
                        "click_action": "https://inclass.app",
                        "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                        "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                        //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                        "sound": "default"
                    },    
                    //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                    "to": tokenFCM
                }

                let axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                    }
                };

                axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                .then((res) => {
                    console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                })
                .catch((err) => {
                    console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                    alert("Erro no envio de push.")
                })

            
                //this.$router.push(`/${slug}/success`)
                this.loading = false
            })
            .catch( error => {
                this.loading = false
                console.log('Error adding document: ', error);
                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
            })
        },
        notificacao(AB, destinatario, enviadoPor){

            db.collection('notificacoes').where("AB", "==", AB)
            .get()
            .then((querySnapshot) => {
                
                if(querySnapshot.size == 0){

                    this.notificacaoAdd(AB, destinatario, enviadoPor);
                    
                }
                else{ // verificar se ja nao existe o AB para salvar notificação
                    var salvarNotificacao = true;
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());
                        let customObj = doc.data()
                        
                        if(customObj.AB == AB){
                            salvarNotificacao = false;
                        }
                        
                    });
                    if(salvarNotificacao == true){
                        this.notificacaoAdd(AB, destinatario, enviadoPor);
                    }
                }
                
            });


            
        },
        enviarMensagem(){
            if(userProperties.escolaID != null){
                //this.loading = true
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second;
                var customtimestampServer = firebase.firestore.Timestamp.fromDate(new Date()).seconds // Timestamp seconds do firebase via server(Segundos) - Da para converter para data via javascript: https://makitweb.com/convert-unix-timestamp-to-date-time-with-javascript/

                const slug = this.generateUUID();
                
                db.collection('mensagens_'+userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        //slugAutor: userProperties.slug,
                        
                        slug: slug,
                        customtimestamp: customtimestamp,
                        customtimestampServer: customtimestampServer,
                        AB: this.ordemSlug,
                        mensagem: this.texto,
                        slugAutor: userProperties.slug,

                        dia: day,
                        mes: month,
                        ano: year,

                        hora: hour,
                        minuto: minute,

                        ordem: this.ordem

                        // AB: this.AB,
                        // titulo: this.titulo,
                        // titulo: this.titulo,
                        // descricao: this.descricao,
                        // rating: this.rating,
                        // comentarioEscola: null
                    })
                    .then(docRef => {

                        console.log('Document written with ID: ', docRef.id);
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.texto = ""
                        this.notificacao(this.ordemSlug, this.$route.query.slug, userProperties.slug);

                        setTimeout(function(){ document.body.scrollTop = document.body.scrollHeight; }, 100);


                    })
                    .catch( error => {
                        this.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
        },
        // carregaDados() {

        //     this.items = []
        //     this.loading = true
        //     let obj = []

        //     // Ordenar exibicao - Ordenacao alfabetica
        //     function compare(a,b) {
        //         if (a.nome < b.nome)
        //             return -1;
        //         if (a.nome > b.nome)
        //             return 1;
        //         return 0;
        //     }
            
        //     db.collection("usuarios")
        //     .where("escolaID", "==", userProperties.escolaID)
        //     .get()
        //     .then((querySnapshot) => {
        //         querySnapshot.forEach(doc => {
                    
        //             // doc.data() is never undefined for query doc snapshots
        //             //console.log(doc.id, " => ", doc.data());                    
        //             let customObj = doc.data()

        //             // recupera imagem do firebase storage
        //             var storageRef = firebase.storage().ref();
        //             var tangRef = storageRef.child('profile/'+customObj.slug+'.'+customObj.extensao);

        //             // First we sign in the user anonymously
        //             //firebase.auth().signInAnonymously().then((result) => {
        //             // Once the sign in completed, we get the download URL of the image
        //             tangRef.getDownloadURL().then(urlImgFB =>                             {
        //                 // Once we have the download URL, we set it to our img element
        //                 this.urlImg = urlImgFB;

        //                 this.items.push({"nome": customObj.nome, "email": customObj.email, "slug": customObj.slug, "imagem": urlImgFB, "perfil": customObj.perfil});
        //                 this.slug = customObj.slug;
        //                 this.loading = false

        //                     // ordenar exibicao - Ordencacao alfabetica
        //                     this.items.sort(compare);

        //                 }).catch(function(error) {
        //                     // If anything goes wrong while getting the download URL, log the error,
        //                     console.error(error);
        //                 });

        //                 // ordenar exibicao - Ordenacao alfabetica
        //                 this.items.sort(compare);
                    
        //         });

                
        //     });

            

        //     // console.log(this.items);
        //     // this.items = obj
        //     // console.log("XXXXXX"+obj)
        // },
        
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection('mensagens_'+userProperties.escolaID).where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.itemsMensagens = [];
                //this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }
    },
    created() {

        this.carregaDados();
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:41%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 112px;
    }

    .minhaImagem{
        float: right;
        right: -8px;
    }

    .outraImagem{
        float: left;
        left: 3px;
    }

    .imagem{
        width: 40px !important;
        height: 40px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top: -8px;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }

    .boxMensagem .v-card{
        border-radius: 8px;
        margin-left: 50px;
        margin-right: 8px;
        margin-top: 10px;
        top: -15px;
        right: 0;
    }

    .boxMensagem div{
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .eu{
        margin-left: 8px !important;
        margin-right: 50px !important;
        background: #bdecb6;
    }

    .v-toolbar{
        margin-bottom: 10px;
    }

    .container .body-content h3.headline{
        font-size: 16px !important;
        line-height: auto !important;
    }

    .miniatura-perfil{
        width: 30px;
        border-radius: 30px;
    }

</style>
